import React from 'react';
import { HStack, VStack } from 'components/muiComponents/stack';
import StepIcon from './StepIcon';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
// import {
//   ClaimSubmissionFormData,
//   CombinedStep,
//   PartialClaimType,
//   SingleStep,
// } from '../../contexts/claimSubmission/claimSubmissionFormData';

interface ProgressStepsProps {
  activeStepIndex: number;
  // secondaryIndex: number;
  // formData: ClaimSubmissionFormData;
  // step: number[];
}
export type SingleStep = {
  title?: string;
};
const generateKey = () => (Math.random() + 1).toString(36).substring(7);
const Container = styled(VStack)`
  align-content: space-between;
  padding-horizontal: 24px;
  margin-top: 20px;
  height: 60px;
  background-color: white;
`;

const LabelContainer = styled(HStack)`
  align-items: flex-start;
  justify-content: space-between;
  flex: 1;
  width: 100%;
`;

// const Spacer = styled(View)`
//   flex: 1;
// `;

const StepsContainer = styled(HStack)`
  padding-left: 7px;
  padding-right: 12px;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;
const step = [{ title: 'registration.start' }, { title: 'registration.middle' }, { title: 'registration.end' }];

const ProgressSteps = (props: ProgressStepsProps) => {
  const {
    activeStepIndex,
    // step,
    // // secondaryIndex,
    // // formData: { steps, partialClaimType },
  } = props;
  const { t } = useTranslation();

  const renderStepIcons = () => {
    const stepIcons: JSX.Element[] = [];
    if (step == undefined || step.length <= 0) {
      return stepIcons;
    }

    for (let i = 0; i < step.length; i++) {
      const isCompletedStep = i < activeStepIndex || activeStepIndex == step.length - 1;
      const isActiveStep = i == activeStepIndex;
      stepIcons.push(
        <StepIcon
          key={generateKey()}
          stepNum={i + 1}
          isFirstStep={i == 0}
          isLastStep={i == step.length - 1}
          isCompletedStep={isCompletedStep}
          isActiveStep={isActiveStep}
        />,
      );
    }

    return stepIcons;
  };

  // const getTitle = () => {
  //   // if (activeStepIndex == 1 && (steps[activeStepIndex] as CombinedStep).titles !== undefined) {
  //   //   if (secondaryIndex == 0 && partialClaimType == PartialClaimType.FULL_CLAIM) {
  //   //     return t((steps[activeStepIndex] as CombinedStep).titles[1]);
  //   //   }
  //   //   return t((steps[activeStepIndex] as CombinedStep).titles[secondaryIndex]);
  //   // }

  //   return t((step[activeStepIndex] as SingleStep).title);
  // };

  const renderLabels = () => {
    // const labels = [];

    if (step == undefined) {
      return [];
    }

    if (activeStepIndex < 0 || activeStepIndex >= step.length) {
      return [];
    }
    const labels = step.map((item, index) => {
      return (
        <Typography.Text
          key={index}
          style={{
            width: '100px',
            color: index <= activeStepIndex ? '#C21B17' : '#6F7072',
            textAlign: 'center',
            fontWeight: index <= activeStepIndex ? 'bold' : 'normal',
            fontFamily: 'Roboto400',
            fontSize: '15px',
            whiteSpace: 'pre-line',
          }}
        >
          {t(item.title)}
        </Typography.Text>
      );
    });
    // labels.push(
    //   <StyledText
    //     key={generateKey()}
    //     body1
    //     bold
    //     color="white"
    //     style={{ flex: 1, textAlign: getLabelAlignment() }}>
    //     {t((step[activeStepIndex] as SingleStep).title)}
    //   </StyledText>,
    // );

    // if (activeStepIndex == 1) {
    //   labels.push(<Spacer key={generateKey()} />);
    // }
    return labels;
  };

  // const getLabelAlignment = (index) => {
  //   if (index == 0) {
  //     return 'left';
  //   } else if (index == 2) {
  //     return 'right';
  //   }

  //   return 'center';
  // };

  return (
    <Container {...props} key={generateKey()}>
      <StepsContainer key={generateKey()}>{renderStepIcons()}</StepsContainer>
      <LabelContainer key={generateKey()}>{renderLabels()}</LabelContainer>
    </Container>
  );
};

export default ProgressSteps;
